import { Control } from "ol/control";
import * as d3 from "d3";
import c3 from "c3";


/**
 * Ok. this is extension of basic OpenLayers Control, to make graph float over map.
 * In control we only show the graph and control nothing.
 *
 * Problem is class is the extension of Control.
 * So no custom variables/methods before you instantiate it.
 * 1st call in constructor should be super() to make instance.
 * But before that we have to make container HTML node so "this." before super() is null. error!
 *
 */
export class GraphControl extends Control {
	constructor() {
		let articleNode = document.createElement("article");
		articleNode.className = "ol-unselectable ol-control";
		articleNode.id = "graphContainer";

		// at this point instance is made so this. !== null. from here on
		super({ element: articleNode });

		const headerSection = document.createElement("header");
		articleNode.append(headerSection);


		const closeButton = document.createElement("button");
		closeButton.type = "button";
		closeButton.innerHTML = "&times;";
		closeButton.style.float = "right";
		closeButton.onclick = closeButton.ontouchstart = (anyEvent) => {
			if (anyEvent.cancelable) anyEvent.preventDefault();
			if (anyEvent.bubbles) anyEvent.stopPropagation();

			this.element.style.display = "none";
		};

		headerSection.append(closeButton);

		const toggleSlideBtn = document.createElement("button");
        toggleSlideBtn.innerHTML = `
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<!-- Axes -->
			<line x1="4" y1="20" x2="20" y2="20" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
			<line x1="4" y1="20" x2="4" y2="4" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
			
			<!-- Graph line -->
			<polyline points="5,18 10,12 15,15 19,8" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			
			<!-- Points -->
			<circle cx="5" cy="18" r="1.5" fill="white"/>
			<circle cx="10" cy="12" r="1.5" fill="white"/>
			<circle cx="15" cy="15" r="1.5" fill="white"/>
			<circle cx="19" cy="8" r="1.5" fill="white"/>
		</svg>
		`;

		const svg = toggleSlideBtn.querySelector("svg");
		svg.style.transform = "translate(-12px, -12px)";
        toggleSlideBtn.style.position = "absolute";
        toggleSlideBtn.style.top = "50%";
        toggleSlideBtn.style.right = "-40px";
        toggleSlideBtn.style.padding = "1rem";
		toggleSlideBtn.style.paddingLeft = "1.4rem";
        toggleSlideBtn.style.backgroundColor = "#7f9dc3";
        toggleSlideBtn.style.color = "white";
        toggleSlideBtn.style.border = "none";
		toggleSlideBtn.style.borderTopRightRadius = "50%";
        toggleSlideBtn.style.borderBottomRightRadius = "50%";
        toggleSlideBtn.style.cursor = "pointer";
        toggleSlideBtn.style.transition = "right 0.3s ease"; // Smooth transition for button movement

        let isSliding = false;

		toggleSlideBtn.onclick = () => {
			if (isSliding) {
				articleNode.style.transform = "translateX(0)";
			} else {
				articleNode.style.transform = "translateX(-104%)";
			}
			isSliding = !isSliding;
		};
		

        articleNode.append(toggleSlideBtn);

        // Apply smooth transition for the graphContainer
        articleNode.style.transition = "transform 0.5s ease";

		const tableForData = document.createElement("table");
headerSection.append(tableForData);

// Add some basic styles for the table
tableForData.style.width = "100%";
tableForData.style.borderCollapse = "collapse";  // Ensures no space between cells
tableForData.style.tableLayout = "fixed";  // Fixed layout ensures equal column widths

const tableBody = document.createElement("tbody");
tableForData.append(tableBody);

const appendLineToTable = (headerText, dataText) => {
    if (!headerText || !dataText) return;

    const tableLine = document.createElement("tr");

    const headerCellNode = document.createElement("th");
    headerCellNode.append(headerText);
    headerCellNode.style.textAlign = "right";  // Align text to the left
    headerCellNode.style.paddingRight = "4px";  // Space between header and data
    headerCellNode.style.width = "55%";  // Set width to ensure consistency

    const dataCellNode = document.createElement("td");
    dataCellNode.append(dataText);
    dataCellNode.style.textAlign = "left";  // Align text to the left
    dataCellNode.style.paddingLeft = "4px";  // Space between header and data
    dataCellNode.style.width = "45%";  // Set width to ensure consistency

    tableLine.append(headerCellNode);
    tableLine.append(dataCellNode);

    tableBody.append(tableLine);
}


		const dataTitleNode = document.createElement("span");
		dataTitleNode.innerText = "Podatkovni niz:";
		appendLineToTable(dataTitleNode, document.createTextNode("Premik"));

		//const sensorTitleNode = document.createElement("span");
		//sensorTitleNode.innerText = "Točka:";

		//this.positionText = document.createTextNode("");
		//appendLineToTable(sensorTitleNode, this.positionText);


		const annualTitleNode = document.createElement("span");
		annualTitleNode.innerText = "Povprečna letna hitrost:";

		this.annualText = document.createTextNode("");
		appendLineToTable(annualTitleNode, this.annualText);

		/*
		const infoNode = document.createElement("span");

		const gursLink = document.createElement("a");
		gursLink.href = "https://www.e-prostor.gov.si/podrocja/drzavni-topografski-sistem/drugo/razno/epsg-kode-za-slovenijo/"
		gursLink.target = "_blank";
		gursLink.innerText = "EPSG kode za Slovenijo";

		infoNode.append(gursLink);

		const pause = document.createTextNode(", ");
		infoNode.append(pause);

		const epsgLink = document.createElement("a");
		epsgLink.href = "https://epsg.io/3794";
		epsgLink.target = "_blank";
		epsgLink.innerText = "EPSG:3794";

		infoNode.append(epsgLink);

		appendLineToTable(document.createTextNode("Koordinatni sistem:"), infoNode);
		*/


		this.chartSection = document.createElement("section");
		this.chartSection.className = "chart-container";
		articleNode.append(this.chartSection);

		this.formatMethod = d3.format(".2f");

		// so now we can use this. to declare all th local class variables want
		this.chartConfig = {
			size: {
				width: 800,
				height: 350
			},
			padding: {
				top: 4,
				right: 4,
				bottom: 4,
				left: 70
			},
			data: {
				x: "day", // dates for X-axis are in "x" column
				keys: {
					x: "day", // { day: "2020-05-01", offset: 3.123 },
					value: ["current"]
				},
				names: { current: "Izmerjen premik (mm)" },
				color: () => { return "rgba(0, 0, 255)"; }
			},
			/*color: {
				pattern: ["#0000ff"]
			},*/
			zoom: { enabled: true },
			/* subchart: {
				show: true, // this splits chart to half the hight (too much)
				axis: { x: { show: false } }
			}, */
			axis: {
				x: {
					type: "timeseries", // ISO texts for dates, also auto-sorts them
					localtime: true,
					tick: {
						fit: true,
						format: "%Y-%m-%d", // Date objects are auto created and
						culling: { max: 40 },
						rotate: -45,
						multiline: false,
						count: 40
					},
					height: 80,
					padding: {
						left: 2,
						right: 2
					},
					label: {
						text: "datum meritve",
						position: "outer-center"
					}
				},
				y: {
					tick: {
						format: d3.format(".0f"), // fixed, no rounding, no decimals
						max: 10
					},
					label: {
						text: "Izmerjen premik (mm)",
						position: "outer-middle"
					}
				},
			},
			grid: {
				x: { show: false },
				y: {
					show: true,
					lines: [{ value: 0, class: "thicker" }]
				}
			},
			point: { r: 4 },
			onrendered: () => {
				if (!this.currentLine) {
					this.currentLine = this.chartSection.querySelector(".c3-lines-current > path");
				}

				this.currentLine.style.opacity = 0;
			},
			resize: { auto: true }
		};

		window.addEventListener("resize", () => {
			this.chartApi.resize(); // Dynamically recalculate dimensions
		});
		
		this.chartConfig.bindto = this.chartSection;
		this.chartConfig.data.json = [{ day: "2020-01-01", offset: 5.1 }, { day: "2020-01-02", offset: 4.5 }];

		this.chartApi = c3.generate(this.chartConfig);

		this.element.style.display = "block";
		setTimeout(() => {
			this.chartApi.resize(); 
		}, 0);
		this.element.style.display = "none"; 
	}

	replaceGraphValues (sensor, outsideArray) {
		if (!sensor || !outsideArray || !Array.isArray(outsideArray) || !outsideArray.length) {
			return;
		}

		this.element.style.display = "";

		// this.positionText.textContent = " na " + this.formatMethod(sensor.z) + " metrih nad morjem";

		this.annualText.textContent = this.formatMethod(sensor.meanAnnualOffset) + " mm/leto";

		//this.oldSensor = Object.assign({}, sensor);

		// 1st would be backing up the old
		const oldValues = outsideArray.slice(0);

		oldValues.sort((item1, item2) => { return (item1.day > item2.day); });

		this.chartConfig.data.json = oldValues.slice(0);

		this.chartApi.load(this.chartConfig.data);
	}

}
